import { ChangeDetectionStrategy, Component } from '@angular/core'
import { ViewableIssue } from 'src/app/account/components/issues-view/issues-view.component'
import { Application } from 'src/app/account/services/application.service'
import { SyncPair } from 'src/app/account/services/sync-pair.service'
import { buildDuplicateRowsScenario, buildTripledNameScenario } from '../../mocks/showcase-issue-scenarios-mocks'
import { TestPageMockState } from '../../showcase-mock-state'

/** Issue-dedup scenarios — duplicate rows and repeated display names. */
@Component({
  selector: 'showcase-issue-scenarios',
  templateUrl: './showcase-issue-scenarios.component.html',
  styleUrls: ['./showcase-issue-scenarios.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ShowcaseIssueScenariosComponent {
  readonly duplicateRowsIssues: ViewableIssue[] = buildDuplicateRowsScenario()
  readonly tripledNameIssues: ViewableIssue[] = buildTripledNameScenario()

  constructor(private readonly state: TestPageMockState) {}

  get application(): Application {
    return this.state.application
  }

  get syncPair(): SyncPair {
    return this.state.syncPair
  }
}
